<script setup lang='ts'>
defineOptions({
  inheritAttrs: false,
})

const { disabled, label } = defineProps<{ label: string, name: string, disabled?: boolean }>()

const model = defineModel<boolean>({ default: false })

const id = useId()

const shapeClass = computed(() => ({
  'translate-x-4': model.value,
  'fill-moss-500': !disabled && model.value,
  'fill-carbon-400': !disabled && !model.value,
  'fill-carbon-300': disabled,
}))

// Dim the disabled track too, since the current colors do not have enough contrast.
const trackClass = computed(() => {
  if (disabled) {
    return 'bg-surface-primary cursor-not-allowed'
  }

  return model.value ? 'bg-moss-200 hover:outline-moss-200 cursor-pointer' : 'bg-carbon-200 hover:outline-carbon-200 cursor-pointer'
})
</script>

<template>
  <label :for="name" class="outline-carbon-300 has-[:focus-visible]:outline-carbon-500 dark:has-[:focus-visible]:outline-carbon-200" :class="trackClass">
    <input :id="name" v-bind="$attrs" v-model="model" type="checkbox" role="switch" :disabled="disabled" :aria-describedby="id">
    <span :id="id" class="sr-only">{{ model ? `Deaktiver ${label}` : `Aktiver ${label}` }}</span>
    <Shape variant="hexagon" aria-hidden="true" :class="shapeClass" />
  </label>
</template>

<style scoped lang='postcss'>
label {
  @apply w-9 h-5 flex items-center relative rounded-full px-[2px] outline outline-1 outline-offset-2;
}

input[role='switch'] {
  @apply appearance-none absolute top-0 left-0 bg-transparent !important;
}

svg {
  @apply w-4 transform ease-out duration-300 transition-all;
}
</style>
